<template>
  <div id="hvac-container">
    <header class="header-text">
      HVAC Detail
    </header>
    <div class="hvac-detail">
      <div class="hvac-detail-left">
        <div class="text-container">
          <label class="label-text">System Age</label>
          <span class="dynamic-text">{{ systemAge(hvac.systemAge) }} </span>
        </div>
        <div class="text-container">
          <label class="label-text">Mfg Date</label>
          <span class="dynamic-text">{{ hvac.mfgDate || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Manufacturer</label>
          <span class="dynamic-text">{{ hvac.manufacturer || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Make</label>
          <span class="dynamic-text">{{ hvac.make || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Model</label>
          <span class="dynamic-text">{{ hvac.model || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Serial Number</label>
          <span class="dynamic-text">{{ hvac.serialNumber || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Type</label>
          <span class="dynamic-text">{{ hvac.type || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Speed</label>
          <span class="dynamic-text">{{ hvac.speed || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Tonnage</label>
          <span class="dynamic-text">{{ hvac.tonnage || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Condenser Amp</label>
          <span class="dynamic-text">{{ hvac.condenserAmp || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Seer</label>
          <span class="dynamic-text">{{ hvac.seer || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Eer</label>
          <span class="dynamic-text">{{ hvac.eer || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Refrigerant</label>
          <span class="dynamic-text">{{ hvac.refrigerant || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Factory Charge</label>
          <span class="dynamic-text">{{ hvac.factoryCharge || '--' }}</span>
        </div>
        <div class="text-container">
          <label class="label-text">Warranty Expiration Date</label>
          <span class="dynamic-text">{{ dateV2(hvac.warranty) }}</span>
        </div>
      </div>
      <div class="hvac-image-right">
        <HVACImage
          :imageUrl="hvac.imageUrl"
          :uploadOption="false"
          :nameplateOption="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import systemHealthMixin from '@shared/mixins/systemHealthMixin';
import HVACImage from '@shared/components/customerDetail/HVACImage.vue';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'HvacDetail',
  components: {
    HVACImage,
  },
  mixins: [systemHealthMixin, unitPreferencesMixin],
};
</script>

<style lang="scss">

#hvac-container {
  background-color: $WHITE;
  padding: 1rem;
  max-height: 350px;
  overflow-y: scroll;
  box-shadow: 0 1px 10px 0 rgba(9, 15, 32, 0.1);
  border-radius: 4px;
  .header-text {
    padding: 4px;
    color: $N60;
    font-weight: 600;
    font-size: 17px;
    border-bottom: 1px solid $N10;
  }

  .hvac-detail {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 1rem;
    .hvac-detail-left {
      padding: 16px 4px;
      display: grid;
      grid-auto-flow: row;
      gap: 10px;
      font-weight: 600;
      font-size: 12.67px;

      .text-container {
        display: grid;
        grid-auto-flow: column;
        justify-content: space-between;
        .label-text {
          text-transform: uppercase;
          color: $N50;
        }
        .dynamic-text {
          color: $N80;
        }
      }
    }
    .hvac-image-right {
      padding: 1rem;
      width: 200px;
      height: 220px;
      display: flex;
      justify-content: center;
      .hvac-image {
        border-radius: 10px;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
